import { TranslateFileLoader } from 'src/app/translate-file-loader';

export function createTranslateLoader() {
  return new TranslateFileLoader();
}
